<template>
    <div class="main-demo">
        <section class="demo-hero">
            <div class="bg-shape shape-left"></div>
            <div class="bg-shape shape-right"></div>

          

            <div class="content">
                <!---<div class="badge">DEMO CENTER</div>-->

                <h1>See AMLLink in Action</h1>

                <p>
                Watch quick demonstrations of how AMLLink streamlines compliance,<br>
                customer onboarding, and transaction monitoring.
                </p>

                <button @click="redirectToContact()">
                Request a Live Demo                     

                </button>
                <div class="play-circle absolute">
                    <div class="play-icon"></div>
                </div>
            </div>
        </section>
        <div id='about' class="section flex items-center justify-center column gap-20 p-20">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                Experience AMLLink On-Demand
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-20" >
                Choose an on-demand demonstration at your convenience. Designed for you to see how AMLLink enables organizations to simplify their Transaction Monitoring process quickly and with confidence
            </div>
            <div class="flex gap-40 blocks">
                <div class="block flex column align-center flex-1 ">
                    <div class="icon-section" @click="openVideo('step1')">

                        <img src="https://media.amllink.com/demo/step1.png" class="image-preview" >
                        <div class="button-play">
                            <div class="play-icon"></div>
                        </div>
                    </div>
                    <div class="flex column gap-20 p-20">
                        <div class="block-header bold font-size-18">AMLLink Reporting Tool</div>
                        <div class="block-description">Shows the functionality of the tool in terms of selecting, editing, and converting the templates into files that can be imported into the GOAML Portal.</div>
                        <div class="info-row flex row space-between w-full align-center ">
                            <div class="text-duration flex row gap-5px align-center no-wrap">
                                <img src="@/assets/clock.svg" style="width: 20px; height: 20px;">
                                Duration: 3 min
                            </div>
                            <button 
                                @click="openVideo('step1')"
                                class="button w-content transparent" style="margin:0">Watch Demo</button>
                        </div>
                    </div>
                </div>
                <div class="block flex column align-center flex-1">
                    <div class="icon-section" @click="openVideo('step2')">
                        <img src="https://media.amllink.com/demo/step2.png" class="image-preview" >
                        <div class="button-play">
                            <div class="play-icon"></div>
                        </div>
                    </div>
                    <div class="flex column gap-20 p-20 flex-1 border-box" style="width: 100%;">

                    <div class="block-header bold font-size-18">GOAML Export Demo</div>
                        <div class="block-description">Shows the process of importing the converted files into the GOAML Portal.</div>
                        <div class="info-row flex row space-between w-full align-center" style="margin-top: auto;">
                            <div class="text-duration flex row gap-5px align-center no-wrap">
                                <img src="@/assets/clock.svg" style="width: 20px; height: 20px;">
                                Duration: 2 min
                            </div>
                            <button 
                                @click="openVideo('step2')"
                                class="button w-content transparent" style="margin:0">Watch Demo</button>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="learn-block gap-20 p-20">
                <div class="headers flex row gap-20 align-center">
                    <div class="icon-space flex align-center justify-center">
                        <img src="@/assets/graduation.svg"/>
                    </div>
                    <div class="text-header bold font-size-22 text-left">
                        What You'll Learn
                    </div>
                </div>
                <div class="dividor"></div>
                <div class="learned-stuff flex column gap-15">
                    <div class="point flex gap-10">
                        <div class="img-bg">
                            <img src="@/assets/checkmark.svg"/>
                        </div>
                        <div class="point-text text-left">How to populate Excel with your data</div>
                    </div>
                     <div class="point flex gap-10">
                        <div class="img-bg">
                            <img src="@/assets/checkmark.svg"/>
                        </div>
                        <div class="point-text text-left">Scenario selection and report generation</div>
                    </div>
                </div>
                <div class="dividor"></div>

                <div class="learned-stuff">
                    <div class="point flex gap-10">
                        <div class="img-bg">
                            <img src="@/assets/checkmark.svg"/>
                        </div>
                        <div class="point-text text-left">GOAML bulk import</div>
                    </div>
                </div>
            </div>
            <div class="question flex row align-center">
                <div class="img">
                    <img src="https://media.amllink.com/demo/pc2.png" class="pc"/>
                </div>
                <div class="info flex column gap-20">
                    <div class="bold font-size-24 text-left">
                        Still have questions?
                    </div>
                    <div class="font-size-18 text-left text-desc point-text" style="max-width: 420px;">
                        Our team is here to help you see how AMLLink can meet your organization's reporting needs.
                    </div>
                    <div class="flex gap-20">
                        <button @click="redirectToContact()" class="w-content"> 
                            Schedule a Live Demo
                        </button>
                        <router-link class="w-content link-item button no-underline" to="/login">
                            <button class="button transparent">Sign Up for Free</button>
                        </router-link> 
                    </div>
                </div>
            </div>
        </div>
        <Footer :homepage="true"/>

            <PopupCover v-if="showPopup" @close="() => showPopup = false">
                <PopupBody @close="() => showPopup = false" class="body-container" >
                        <template #header> Video Demo</template>
                        <template #body>
                       
                            <div class="main-container">    
                                <video :src="steps[showPopup]" controls autoplay="true" >

                                </video>
                            </div>
                        </template>
                </PopupBody>
            </PopupCover>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    import PopupCover from '@/components/PopupCover.vue';
    import PopupBody from '@/components/PopupBody.vue';
    import Footer from '@/components/Footer.vue'
    import { useRouter } from 'vue-router';


    const router = useRouter();

    const showPopup = ref(false)
    const steps = {
        'step1': 'https://media.amllink.com/demo/step_1.webm',
        'step2': 'https://media.amllink.com/demo/step_2.webm',
    }

    function openVideo(video){
        showPopup.value = video;
    }

    function redirectToContact(){
        router.push('/?to=contact')
    }

</script>

<style lang="scss" scoped>
    .dividor {
        max-width: 1px;
        width: 1px;
        background-color: var(--border-color);
    }
    .pc {
        width: 400px;
    }
  
    .icon-space {
        width: 70px;
        height: 70px;
        min-width: 70px;
        border-radius: 50%;
        background-color: #d4e4f8;
        img {
            width: 35px;
            height: 35px;
        }
    }
    .point-text {
        color: rgb(75, 85, 99);
    }
    .text-header {
        position: relative;
        margin-bottom: 20px;
     
        &::after {
            content: '';
            position: absolute;
            bottom: -15px;
            left: 0;
            width: 55px;
            height: 4px;
            background-color: var(--primary-color);
        }
    }
    .main-demo {
        padding-bottom: 100px;
    }
    .body-container {
        width: 90vw;
        height: 90vh;
    }

    .main-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .main-container video {
        width: 100%;
        height: 100%;
        object-fit: contain;  /* keeps aspect ratio, no cropping */
    }
    .demo-hero {
        position: relative;
        height: 290px;
        overflow: hidden;
        background:
            radial-gradient(circle at 50% 30%, rgba(222, 237, 255, 0.55), transparent 35%),
            linear-gradient(180deg, #ffffff 0%, rgba(204, 218, 234, 0.2) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Inter, Arial, sans-serif;
    }


/* left flowing wave */
.shape-left {
  position: absolute;
  left: -180px;
  top: -100px;
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      ellipse at center,
      rgba(200,220,255,.45),
      rgba(220,235,255,.2) 40%,
      transparent 70%
    );
  border-radius: 50%;
  transform: rotate(-25deg);
}
.info-row {
  color:#53627a;
}

/* right soft glow */
.shape-right {
  position: absolute;
  right: -120px;
  top: 20px;
  width: 400px;
  height: 400px;
  background:
    radial-gradient(
      circle,
      rgba(220,235,255,.7),
      transparent 65%
    );
}


/* play button */
.play-circle {
  position:absolute;
  right: -150px;
  top: 65px;

  width:90px;
  height:90px;
  border-radius:50%;

  background:
    radial-gradient(
      circle,
      rgba(120,170,255,.25),
      rgba(120,170,255,.08)
    );

  display:flex;
  align-items:center;
  justify-content:center;
}


.play-icon {
    margin-left:5px;
    width:0;
    height:0;

    border-top:15px solid transparent;
    border-bottom:15px solid transparent;
    border-left:24px solid #76a8ff;
 
}


/* text */
.content {
  position:relative;
  z-index:2;
  text-align:center;

}


.badge {
  display:inline-block;
  padding:8px 22px;

  font-size:13px;
  font-weight:600;
  color:#2475e8;

  background:#d4e4f8;
  border-radius:30px;

  margin-bottom:25px;
}


h1 {
  margin:0;

  font-size:44px;
  font-weight:800;
  letter-spacing:-1px;

  color:#14213d;
}


p {
  margin-top:28px;

  font-size:18px;
  line-height:32px;

  color:#53627a;
}



button span {
  margin-left:18px;
  font-size:22px;
}



.logged-in-view {
        padding-top: 40px;
        margin: auto;
        max-width: 1070px;
    }

    .cards {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
    }
    .card {
        max-width: 340px;
        flex: 1;
        background-color: white;
        border: 1px solid var(--border-color);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-radius: 10px;
        overflow: hidden;
    }
    .image-section-top {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('@/assets/top-cover_.png');
        background-repeat: no-repeat;
        background-position: right;
        background-size: cover;
        filter: brightness(0.5)

    }
    .top-texts {
        z-index: 3;
        position: relative;
        color: white;
    }
    .img-section {
        background-color: rgb(249 250 251);
        height: 120px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        filter: brightness(0.7);
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .card-texts {
        padding: 20px;
        text-align: left;
    }
    .card-header {
        font-size: 20px;
    }
    .top-section-home {
        position: relative;
        background-color: white;
        padding: 20px;
        text-align: left;
        border: 1px solid var(--border-color);
        border-radius: 10px;
        height: 177px;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
      
    }
    .opacity-50 {
        opacity: 0.5;
    }
    .header-text {
        line-height: 2.45rem;
    }
    .home-page {
        background-color: rgb(255 255 255);
    }
    .top-section-subtext {
        color: rgb(75 85 99);
        max-width: 850px;
    }
    .links a {
        color: rgb(75 85 99);
        transition: all 0.3s ease;
        &:hover {
            color: var(--primary-color);
        }
    }
    .dividor-header {
        width: 100px;
        height: 4px;
        background-color: var(--primary-color);
        margin: 20px auto 0 auto;
    } 
    .block-header {
        text-align: left;
        width: 100%;
    }
    .block {
        overflow: hidden;
        text-align: left;
        background-color: rgb(249 250 251);
        border-radius: 10px;
        box-shadow:  2px 2px 10px 0 rgb(0 0 0 / 0.1);
        transition: all 0.3s ease;
        position: relative;
        top: 0;
        &:hover {
            top: -2px;
            box-shadow: 0 10px 15px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        }
    }
    .question {
        border: 1px solid var(--border-color);
        border-radius: 10px;
        box-shadow:  2px 2px 10px 0 rgb(0 0 0 / 0.1);
        padding: 20px;
        width: 100%;
        max-width: 1000px;
        margin-top: 30px;
        box-sizing: border-box;
        background: #fafcff;
    
    }
    .learn-block {
        border: 1px solid var(--border-color);
        border-radius: 10px;
        box-shadow:  2px 2px 10px 0 rgb(0 0 0 / 0.1);
        background-color: rgb(248, 251, 254);
        padding: 40px 20px;
        box-sizing: border-box;
        width: 100%;
        max-width: 1000px;
        margin-top: 30px;
        display: flex;
        flex: 1;

        & > *{
            flex: 1;
            justify-content: flex-start;
        }

    }
    .img-bg {
        background-color: var(--primary-color);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        min-width: 20px;
        img {
            width: 12px;
            height: 12px;
        }
    }
    .button-play {
        display: none;
        position: absolute;
        background-color: white;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .icon-section {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 220px;
        &:hover {
            .button-play {
                display: flex;
            }
            .image-preview {
                filter: brightness(0.7);
            }
        }
    }
    .image-preview {
        object-fit: cover;
        width: 100%;
        transition: filter 0.25s;
        cursor: pointer;
        border: 1px solid var(--border-color);
        // border-radius: 10px;
    }
    .block-description {
        color: rgb(75 85 99);
        font-size: 16px;
        width: 100%;
    }
    .blocks {
        max-width: 1000px;
        box-sizing: border-box;
    }
    .features, .pricing {
        max-width: 1152px;
    }
    .section {
        padding: 40px 20px;
    } 
  
    .top-section {
        height: calc(100vh - 128px);
    }
    .approach-block {
        flex: 1;
        background-color: white;
        // padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow:  0 1px 2px 0 rgb(0 0 0 / 0.05);
        transition: all 0.3s ease;
        position: relative;
        top: 0;
        &:hover {
            top: -10px;
            box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        }
    } 
    .point-square {
        background-color: rgb(249 250 251);
        padding: 10px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 200px;
    }
    .point-description {
        color: rgb(75 85 99);
    }

    .top-line {
        width: 100%;
        height: 8px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        &.blue {
            background-color: var(--primary-color);
        }  
        &.purple {
            background-color: rgb(147 51 234)
        }
    } 
    .pricing-block {
        background-color: white;
        padding: 0px;
        border-radius: 10px;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

        .block-description {
            margin-bottom: 20px;
        }
        > div {
            padding: 24px;
            width: 100%;
            box-sizing: border-box;
        }
    }
    .price {
        display: flex;
        align-items: baseline;
        font-weight: 600;
    }
    .item-service {
        font-size: 14px;
        color: rgb(75 85 99);
        font-weight: 500;
    }
    .contact-block {
        background-color: white;
        flex: 1;
        padding: 24px;
        border-radius: 10px;
        width: 900px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    }
    .question-label {
        width: fit-content;
        background-color: white;
        font-size: 11px;
        position: relative;
        padding: 0 5px;
        bottom: -10px;
        left: 5px;
    }

    textarea {
        width: 95%;
        resize: none;
        height: 150px;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 20px;
        &:focus {
            outline: none;
            border: 1px solid var(--primary-color);
        }
    }
    .contact-description {
        color: rgb(75 85 99);
        
        font-size: 14px;
    }
    .animation-part {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 9999;
    }
    .letter-spacing {
        letter-spacing: 5px;
    }
    .logo-animation {
        position: relative;
        cursor: pointer;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid var(--primary-color);
        transition: all 0.3s ease;
        &:hover {
            background-color: var(--primary-color);
            svg {
                stroke: white;
                fill: white;
            }
        }
        svg {
            stroke: var(--primary-color);
            fill: var(--primary-color);
            width: 30px;
            height: 30px;
            animation: bounce 2s infinite;
        }
        .pulsar {
            position: absolute;
            width: 100px;
            height: 100px;
            border-radius: 50%;
            // background-color: var(--primary-color);
            border-radius: 50%;
            border: 1px solid var(--primary-color);
            animation: pulsate 1s infinite cubic-bezier(0, 0, 0.2, 1);
            opacity: 0.5;
        }

    }
    .darker {
        background-color: rgb(249 250 251)
    }
    .footer-block {
        width: 100%;
        margin-left: 50px;
    }

    @media screen and (max-width: 1080px) {
        .blocks {
            flex-direction: column;
        }
        .question {
            flex-direction: column;
        }
        .learn-block {
            flex-direction: column;
            .dividor {
                width: 100%;
                height: 1px;  
                max-width: unset;
                flex: unset;
            }
        }
        .demo-hero {
            padding: 20px;
            height: fit-content;
        }
    }
</style>